module.exports = __webpack_public_path__ + "img/appIcon-menu--Reports--active.5197026b.svg";